<template>
  <div class="box" @click="complete">
    <div class="box-img">
      <img :src="enterpriseItem.portraitUrl" alt="url" v-if="enterpriseItem.portraitUrl" class="img-customer">
      <div :style="{ 'background-color': getBgColor(enterpriseItem.name) }" v-if="!enterpriseItem.portraitUrl && enterpriseItem.name" class="img-customer">
        {{getNameTag(enterpriseItem.name)}}
      </div>
    </div>
    <div class="box-title">
      <div class="box-name">{{name}}</div>
      <div class="box-zhu" style="color:#fff;">({{type}})</div>
    </div>
    <div class="star-box now-login" v-if="isCurrentLogin">
      <div class="round"></div>
      <div>当前登录</div>
    </div>
  </div>
</template>

<script>
const url = require('@/assets/imgs/touxiang.png')
import getColor from '../../mixins/getColor'
import { mapState } from 'vuex'
export default {
  props: {
    url: {
      type: String,
      default: url
    },
    enterpriseItem: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  mixins:[getColor],
  computed: {
    ...mapState([
      'enterpriseId'
    ]),
    isCurrentLogin() {
      return this.enterpriseId === this.enterpriseItem.enterpriseId
    },
    name() {
      if (this.enterpriseItem) {
        return this.enterpriseItem.name || this.enterpriseItem.dpuid
      }
      return ''
    },
    type () {
      if (this.enterpriseItem.verification && this.enterpriseItem) {
        return this.enterpriseItem.enterpriseType === 0 ? '个人账号' : '机构账号'
      }
      return '未实名'
    },
    role () {
      if (this.enterpriseItem) {
        return this.enterpriseItem.role === 1 ? '主账号' : '子账号'
      }
      return ''
    }
  },
  methods: {
    complete () {
      this.$emit('complete', this.enterpriseItem.dpuid, this.enterpriseItem.enterpriseId)
    }
  }
}
</script>

<style lang="scss" scoped>
  .box{
    width: calc(100% - 30px);
    margin: 0 auto;
    height: 70px;
    display: flex;
    align-items: center;
    padding-left: 30px;
    box-sizing: border-box;
    cursor: pointer;
    background-color: $sub-color;
    margin-top: 10px;
    position: relative;
		color: #fff;
		border-radius: 8px;
  }
  .img-customer{
    width:50px;
    height: 50px;
    border-radius: 50%;
    line-height: 50px;
    text-align: center;
    font-size: 18px;
	}
  .box-img{
    width: 45px;
    height: 45px;
  }
  .box-image{
    font-size: 45px;
    line-height: 45px;
    color: $button;
  }
  .box-img image{
    width: 100%;
    height: 100%;
  }
  .box:hover{
    background-color: #4D5155;
  }
  .box-title{
    margin-left: 20px;
  }
  .box-name{
    font-size: 14px;
  }
  .box-zhu{
    font-size: 14px;
    color: #5a5a5a;
    margin-top: 3px;
  }
  .round{
		width: 10px;
		height: 10px;
		background-color: green;
		border-radius: 100%;
		margin-right: 5px;
	}
  .now-login{
    position: absolute;
    right: 15px;
  }
  .star-box{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
</style>